export interface TelegramWebApp {
  initData: string;
  colorScheme: "light" | "dark";
  ready: () => void;
  expand: () => void;
  MainButton?: {
    hide: () => void;
  };
}

declare global {
  interface Window {
    Telegram?: {
      WebApp?: TelegramWebApp;
    };
  }
}

export function setupTelegramShell(): void {
  const webApp = window.Telegram?.WebApp;
  webApp?.ready();
  webApp?.expand();
  webApp?.MainButton?.hide();
  document.documentElement.dataset.tgTheme = webApp?.colorScheme ?? "dark";
}

export function getTelegramInitData(): string {
  return window.Telegram?.WebApp?.initData ?? "";
}
